import { render } from "./QuestionEditor.vue?vue&type=template&id=42144f90&scoped=true"
import script from "./QuestionEditor.vue?vue&type=script&lang=js"
export * from "./QuestionEditor.vue?vue&type=script&lang=js"

import "./QuestionEditor.vue?vue&type=style&index=0&id=42144f90&scoped=true&lang=css"

import exportComponent from "/home/tewky/cloverhitch/pelican/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42144f90"]])

export default __exports__